import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import { UPDATE_DRAWER_ERROR, UPDATE_DRAWER_START, UPDATE_DRAWER_SUCCESS } from "../../types";

export function* update({payload}) {
    try {
        const url = `/drawer/${payload.formData.id}/`;
        const method = 'PUT';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'multipart/form-data'};
        const data = (object) => Object.keys(object).reduce((formData, key) => {
            formData.append(key, object[key]);
            return formData;
        }, new FormData());
        const results = yield call(apiCall, url, method, data(payload.formData), headers);
        yield put({type: UPDATE_DRAWER_SUCCESS, results: results.data});
        yield put(payload.navigate('/app/content-management/manage-drawer'));
    } catch (error) {
        yield put({type: UPDATE_DRAWER_ERROR, error});
    }
}

export default function* update_drawer() {
    yield takeLatest(UPDATE_DRAWER_START, update);
}